import { ApiService, ConfigApi, SettingsService, StorageService } from 'services';
import {
    IConfigApi,
    IApiService,
    ISettingsService,
    IStorageService,
    IActionApi,
    ICommitteeApi,
    ISpeakersApi,
    ISponsorsApi,
    IProgramApi,
    IMediaTagsApi,
    IMediaApi,
    IConferenceApi,
} from 'types';

import {
    SponsorsApi,
    SpeakersApi,
    CommitteeApi,
    ActionsApi,
    ProgramApi,
    MediaTagsApi,
    MediaApi,
    ConferenceApi,
    ConfirmationApi,
} from './api';
import { IConfirmationApiService } from 'types/confirmation-api';

export const getApiService = (tokenStorageService: IStorageService): IApiService => new ApiService(tokenStorageService);
export const getConfigApiService = (apiService: IApiService): IConfigApi => new ConfigApi(apiService);
export const getActionsApiService = (apiService: IApiService): IActionApi => new ActionsApi(apiService);
export const getCommitteeApiService = (apiService: IApiService): ICommitteeApi => new CommitteeApi(apiService);
export const getSpeakersApiService = (apiService: IApiService): ISpeakersApi => new SpeakersApi(apiService);
export const getSettingsService = (): ISettingsService => new SettingsService();
export const getStorageService = (): IStorageService => new StorageService();
export const getSponsorsApiService = (apiService: IApiService): ISponsorsApi => new SponsorsApi(apiService);
export const getProgramApi = (apiService: IApiService): IProgramApi => new ProgramApi(apiService);
export const getMediaTagsApi = (apiService: IApiService): IMediaTagsApi => new MediaTagsApi(apiService);
export const getMediaApi = (apiService: IApiService): IMediaApi => new MediaApi(apiService);
export const getConferenceApi = (apiService: IApiService): IConferenceApi => new ConferenceApi(apiService);
export const getConfirmationApi = (apiService: IApiService): IConfirmationApiService => new ConfirmationApi(apiService);
